export default "__VITE_ASSET__CMlIiW_t__"